import React from 'react'
import './StepIndicator.css'

const STEPS = [
  { number: 1, label: 'Your Details' },
  { number: 2, label: 'Scan & Pay'   },
  { number: 3, label: 'Confirm'      },
]

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true">
    <polyline points="20 6 9 17 4 12" className="step__check-path" />
  </svg>
)

const StepIndicator = ({ currentStep }) => {
  return (
    <nav className="step-indicator" aria-label="Payment steps">
      <ol className="step-indicator__list">
        {STEPS.map((step, index) => {
          const isCompleted = currentStep > step.number
          const isActive    = currentStep === step.number
          const status = isCompleted ? 'completed' : isActive ? 'active' : 'pending'

          return (
            <React.Fragment key={step.number}>
              <li
                className={`step-indicator__item step-indicator__item--${status}`}
                aria-current={isActive ? 'step' : undefined}
              >
                <div className="step-indicator__circle" aria-hidden="true">
                  {isCompleted ? <CheckIcon /> : <span>{step.number}</span>}
                </div>
                <span className="step-indicator__label">{step.label}</span>
              </li>

              {/* Connector line between steps */}
              {index < STEPS.length - 1 && (
                <div
                  className={`step-indicator__connector ${currentStep > step.number ? 'step-indicator__connector--done' : ''}`}
                  aria-hidden="true"
                />
              )}
            </React.Fragment>
          )
        })}
      </ol>
    </nav>
  )
}

export default StepIndicator
